import React, {useContext, useEffect, useState} from "react";
import { useForm } from "react-hook-form";
import { Button, SubTitle, Spacer, Toggle, Dropdown, Text } from "@dspworkplace/ui";
import { useAuth } from "../../../Auth";
import SettingsContext from "../context";
import { getCompanyId, showToast } from "../../../Utilities";
import WorkHourComplianceNotifyUsers from "./WorkHourComplianceNotifyUsers";
import { AccessCheck, IsGranted } from "../../../security";
import Modal from "../../../components/Modal";
import { HelpButton } from "../../../components/UI";

async function updateWorkHourComplianceNotifyUsers(api, workHourComplianceNotifyUsers) {
    try {
        await api.post('/api/bot/twilio/employees', {
            companyId: getCompanyId(),
            update: 'workHourComplianceNotifyUsers',
            workHourComplianceNotifyUsers,
        });
        return true
    } catch (e) {
        return false;
    }
}
const generateTimeOptions = (max) => 
    Array.from({ length: max }, (_, i) => {
      const value = i.toString().padStart(2, '0');
      return { name: value, value };
    });
    

const WorkHourComplianceWarning = () => {
    const { register, handleSubmit, watch, reset} = useForm();
    const { api } = useAuth();
    const [state, dispatch] = useContext(SettingsContext);
    const workHourComplianceWarning = watch("workHourComplianceWarning");
    const workingHourWarning = watch("workingHourWarning");
    const [showHelp, setShowHelp] = useState(false);

    const optionHours = generateTimeOptions(24);
    const optionMinutes = generateTimeOptions(60);
    const optionReviewHours = generateTimeOptions(81);

    useEffect(() => {
        const workHourComplianceWarningSendAt = (state.company.workHourComplianceWarningSendAt ? (state.company.workHourComplianceWarningSendAt):"").split(":");
        const workHourReviewTimePeriod = (state.company.workHourReviewTimePeriod ? (state.company.workHourReviewTimePeriod):"").split(":");
        const notifyAfterFlexLoginTimePeriod = (state.company.notifyAfterFlexLoginTimePeriod ? (state.company.notifyAfterFlexLoginTimePeriod):"").split(":");
        reset({
            "workHourComplianceWarning" : state.company.workHourComplianceWarning, 
            "workingHourWarning" : state.company.workingHourWarning, 
            "workHourComplianceTimeHour" : workHourComplianceWarningSendAt[0],
            "workHourComplianceTimeMinute" : workHourComplianceWarningSendAt[1],
            "workHourReviewTimeHour" : workHourReviewTimePeriod[0],
            "workHourReviewTimeMinute" : workHourReviewTimePeriod[1],
            "notifyAfterFlexLoginTimeHour" : notifyAfterFlexLoginTimePeriod[0],
            "notifyAfterFlexLoginTimeMinute" : notifyAfterFlexLoginTimePeriod[1]
        });
    }, [state.company]);

    const onSubmit = async (data, evt) => {
        let form = evt.target;
        try {
            form.querySelector('button').disabled = true;
            if(data?.workHourComplianceNotifyUsers?.length == 0){
                data.workHourComplianceNotifyUsers = null;
            }
            let updateRecord = { 
                workHourComplianceWarning: data.workHourComplianceWarning,
                workHourComplianceWarningSendAt: data.workHourComplianceTimeHour+':'+data.workHourComplianceTimeMinute,
                ...(data.workHourComplianceWarning && {
                    notifyAfterFlexLoginTimePeriod: data.notifyAfterFlexLoginTimeHour+':'+data.notifyAfterFlexLoginTimeMinute
                }),
                workingHourWarning: data.workingHourWarning,
                ...(data.workingHourWarning && {
                    workHourReviewTimePeriod: data.workHourReviewTimeHour+':'+data.workHourReviewTimeMinute
                })
            };
            await api.post('/api/lazy/manage/data', {
                actions: {
                    update: {
                        Company: {
                            update_company: {
                                findBy: {
                                    id: getCompanyId()
                                },
                                updateRecord: updateRecord
                            }
                        }
                    }
                }
            });

            await updateWorkHourComplianceNotifyUsers(api, data.workHourComplianceNotifyUsers);
            updateRecord = { 
                ...updateRecord,
                ...{workHourComplianceNotifyUsers: data.workHourComplianceNotifyUsers}
            };

            await showToast({
                type: 'success',
                title: 'Enable Work Hour Compliance Warning',
                content: 'Updates completed'
            });
            form.querySelector('button').disabled = false;
            dispatch({type: 'UPDATE_COMPANY', payload: {company: {...state.company, ...updateRecord}}})
        } catch (e) {
            await showToast({ type: 'error', title: 'Enable Work Hour Compliance Warning', content: JSON.stringify(e) });
            form.querySelector('button').disabled = false;
        }
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <SubTitle>
                Work Hour Compliance Warning
                <HelpButton onClick={() => setShowHelp(true)}>How Does It Work?</HelpButton>
            </SubTitle>
            <Spacer bottom={2} />
                <Spacer top={4}>
                    <label
                        style={{
                            fontSize: "16px",
                            fontWeight: "normal",
                            fontFamily: "Circe-Rounded",
                            display: "block",
                            paddingBottom: "2px",
                            color: "#707070",
                        }}
                    >
                        Send notifications at (station local time)
                    </label>
                    <Dropdown
                        name='workHourComplianceTimeHour'
                        label='Hours'
                        ref={register}
                        placeholder='Hours'
                        options={optionHours}
                        style={{marginRight:'5px',fontSize: "12px"}}
                        size='extraSmall'
                        valid={"true"}
                    />
                    <Dropdown
                        name='workHourComplianceTimeMinute'
                        ref={register}
                        label='Minutes'
                        placeholder='Minutes'
                        options={optionMinutes}
                        style={{}}
                        size='extraSmall'
                        valid={"true"}
                    />
                    <Spacer bottom={5} />
                    <WorkHourComplianceNotifyUsers ref={register} />
                    <Spacer bottom={5} />
                    <Toggle
                        ref={register}
                        name="workHourComplianceWarning"
                        singleText="Send notification HH:MM after Flex login"
                        on={workHourComplianceWarning}
                    />
                    <Spacer bottom={5} />
                    {workHourComplianceWarning && (<Spacer left={10}>
                        <label
                            style={{
                                fontSize: "16px",
                                fontWeight: "normal",
                                fontFamily: "Circe-Rounded",
                                display: "block",
                                paddingBottom: "2px",
                                color: "#707070",
                            }}
                        >
                            Notify after HH:MM after flex login
                        </label>
                        <Dropdown
                            name='notifyAfterFlexLoginTimeHour'
                            label='Hours'
                            ref={register}
                            placeholder='Hours'
                            options={optionHours}
                        style={{marginRight:'5px',fontSize: "12px"}}
                        size='extraSmall'
                            valid={"true"}
                        />
                        <Dropdown
                            name='notifyAfterFlexLoginTimeMinute'
                            ref={register}
                            label='Minutes'
                            placeholder='Minutes'
                            options={optionMinutes}
                            style={{}}
                            size='extraSmall'
                            valid={"true"}
                        />
                    </Spacer>)}
                    <Spacer bottom={5} />
                    <Toggle
                        ref={register}
                        name="workingHourWarning"
                        singleText="60 working hours (last seven days)"
                        on={workingHourWarning}
                    />
                    <Spacer bottom={5} />
                    {workingHourWarning && (<Spacer left={10}>
                        <label
                            style={{
                                fontSize: "16px",
                                fontWeight: "normal",
                                fontFamily: "Circe-Rounded",
                                display: "block",
                                paddingBottom: "2px",
                                color: "#707070",
                            }}
                        >
                            If scheduled for the upcoming day. review hours worked in the past 6 days and notify if exceeding HH:MM
                        </label>
                        <Dropdown
                            name='workHourReviewTimeHour'
                            label='Hours'
                            ref={register}
                            placeholder='Hours'
                            options={optionReviewHours}
                            style={{marginRight:'5px',fontSize: "12px"}}
                            size='extraSmall'
                            valid={"true"}
                        />
                        <Dropdown
                            name='workHourReviewTimeMinute'
                            ref={register}
                            label='Minutes'
                            placeholder='Minutes'
                            options={optionMinutes}
                            style={{}}
                            size='extraSmall'
                            valid={"true"}
                        />
                    </Spacer>)}
                </Spacer>
            <IsGranted feature={AccessCheck.features.SETTINGS} ops={[AccessCheck.OPS.U]}>
                <Spacer bottom={5} />
                <Button type='primary'>Save</Button>
            </IsGranted>
            {!showHelp ? null : (
                <Modal
                    visible={true}
                    setVisible={() => setShowHelp(false)}
                    title={"Work Hours Compliance Warning"}
                    drawer={"right"}
                >
                    <Text>
                        This will send a workbot alert for any employee who has not punched out in the set time period after their Flex Login. For this setting to work, the employee must have both the Flex login time (via RouteAssist) and a punch out (via payroll integration).
                    </Text>
                    <Spacer bottom={5} />
                </Modal>
            )}
        </form>
    );
}

export default WorkHourComplianceWarning;